import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_ENDPOINTS } from '../../config/apiConfig';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../router/authContext";

export const Navigation = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);

  const navigate = useNavigate();
  const { logout } = useAuth();
  useEffect(() => {
    axios.get(API_ENDPOINTS.user, {
      headers: {
        Authorization: `Token ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => {
        setUserData(response.data);
        setIsAuthenticated(true);
      })
      .catch(error => {
        console.log("User is not authenticated", error);
        setIsAuthenticated(false);
      });
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  }

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link className="navbar-brand page-scroll" to="/">
            <img src="../img/logo.png" alt="AmpTrans logo" className="img-responsive" width={'30%'}></img>
          </Link>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <Link to="/calculator" className="page-scroll">
                Solutions
              </Link>
            </li>
            {/* <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li> */}
            <li>
              {isAuthenticated ? (
                <div className="dropdown">
                  <button
                    className="user-btn btn dropdown-toggle"
                    type="button"
                    id="userDropdown"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: '#333', borderRadius: 20, paddingLeft: 20, paddingRight: 20 }}
                  >
                    {userData.first_name}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="userDropdown" style={{
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    padding: '8px 0'
                  }}>
                    <li>
                      <Link to="/profile" className="dropdown-item" style={{
                        padding: '8px 20px',
                        color: '#333'
                      }}>
                        Profile
                      </Link>
                    </li>
                    <li>
                      <button 
                        className="dropdown-item" 
                        onClick={handleLogout}
                        style={{
                          padding: '8px 20px',
                          width: '100%',
                          textAlign: 'left',
                          border: 'none',
                          backgroundColor: 'transparent',
                          color: '#dc3545',
                          cursor: 'pointer'
                        }}
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>
              ) : (
                <Link to="/login" className="btn login-btn" style={{ color: 'white', borderRadius: 20, paddingLeft: 20, paddingRight: 20 }}>
                  Login
                </Link>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
